import { render, staticRenderFns } from "./GooglePlacesAutocomplete.vue?vue&type=template&id=0201edf5&scoped=true"
import script from "./GooglePlacesAutocomplete.vue?vue&type=script&lang=js"
export * from "./GooglePlacesAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./GooglePlacesAutocomplete.vue?vue&type=style&index=0&id=0201edf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0201edf5",
  null
  
)

export default component.exports